import React from 'react';
import {
  makeStyles,
  ClickAwayListener,
  Fade,
  Grid,
  Paper,
  Popper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Badge,
  Tooltip,
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import QueryBuilderTwoToneIcon from '@material-ui/icons/QueryBuilderTwoTone';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';

import notificationIcon from '../../../../assets/svgs/notification.svg';

const useStyles = makeStyles((theme) => ({
  grow: {
    flex: 1,
  },
  root: {
    width: '100%',
    maxWidth: '300px',
    minWidth: '300px',
    backgroundColor: theme.palette.background.paper,
    paddingBottom: 0,
    borderRadius: '10px',
    [theme.breakpoints.down('lg')]: {
      minWidth: '300px',
      maxHeight: '500px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '300px',
      minWidth: '300px',
      maxHeight: '700px',
    },
  },
  popper: {
    [theme.breakpoints.down('xs')]: {
      left: '0',
      right: '0',
      top: '55px !important',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '50%',
      transform: 'none !important',
    },
  },
  inline: {
    display: 'inline',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  subHeader: {
    backgroundColor: theme.palette.grey.A400,
    color: theme.palette.common.white,
    padding: '5px 15px',
  },
  subFooter: {
    backgroundColor: theme.palette.grey.A400,
    color: theme.palette.common.white,
    padding: 0,
  },
  iconButton: {
    padding: '5px',
  },
  showIcon: {
    transform: 'rotate(90deg)',
  },
  listSection: {
    backgroundColor: 'inherit',
    display: 'block',
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0,
  },
  listAction: {
    top: '22px',
  },
  actionIcon: {
    fontSize: '0.75rem',
    marginRight: '4px',
    color: theme.palette.grey[400],
  },
  actionColor: {
    color: theme.palette.grey[400],
  },
  ScrollHeight: {
    height: '500px',
    overflowX: 'hidden',
    [theme.breakpoints.down('lg')]: {
      // minWidth: '500px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '700px',
    },
  },
  p0: {
    padding: 0,
  },
  pT0: {
    paddingTop: 0,
  },
  menuIIcon: {
    fontSize: '1.5rem',
  },
  menuButton: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor: '#F3F8FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fab: {
    width: '32px !important',
    height: '32px !important',
    minWidth: '32px !important',
    minHeight: '32px !important',
  },
}));

const NotificationSection = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [taskList, setTask] = React.useState([]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    // getTask();
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <React.Fragment>
      <Tooltip title="Thông báo" placement="bottom">
        <div
          className={classes.menuButton}
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          color="inherit"
        >
          <Badge badgeContent={1} color="primary" overlap="rectangular">
            <img src={notificationIcon} alt="" className={classes.menuIIcon} />
          </Badge>
        </div>
      </Tooltip>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        className={classes.popper}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: {
            offset: {
              enable: true,
              offset: '0px, 10px',
            },
            preventOverflow: {
              padding: 0,
            },
          },
        }}
      >
        {({ TransitionProps, placement }) => (
          <Fade {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <List className={classes.root}>
                  <PerfectScrollbar className={classes.ScrollHeight}>
                    {taskList.map(({ assigned_date, customer_name, task_title }, index) => (
                      <ListItem button alignItems="flex-start" className={classes.pT0} key={index}>
                        <ListItemAvatar>
                          <AssignmentIndIcon
                            style={{
                              fontSize: '40px',
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography variant="subtitle1">
                              {task_title.length > 50 ? task_title.substring(0, 50) + '...' : task_title}
                            </Typography>
                          }
                          secondary={
                            <Typography variant="subtitle2">
                              {customer_name} Ngày {assigned_date}
                            </Typography>
                          }
                        />
                        <ListItemSecondaryAction className={classes.listAction}>
                          <Grid container justifyContent="flex-end">
                            <Grid item>
                              <QueryBuilderTwoToneIcon className={classes.actionIcon} />
                            </Grid>
                            <Grid item>
                              <Typography
                                variant="caption"
                                display="block"
                                gutterBottom
                                className={classes.actionColor}
                              ></Typography>
                            </Grid>
                          </Grid>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                    {/* {laterTasks.length > 0 && (
                      <ListSubheader disableSticky>
                        <Chip size="small" variant="outlined" label="EARLIER" />
                      </ListSubheader>
                    )} */}
                    {/* {laterTasks.map(
                      (
                        {
                          assigned_date,
                       
                          customer_name,
                        
                          task_url,
                        },
                        index
                      ) => (
                        <ListItem button alignItems="flex-start" className={classes.pT0} key={index}>
                          <ListItemAvatar>
                            <AssignmentIndIcon
                              style={{
                                fontSize: '40px',
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={<Typography variant="subtitle1">{task_url}</Typography>}
                            secondary={
                              <Typography variant="subtitle2">
                                {customer_name} Ngày {assigned_date}
                              </Typography>
                            }
                          />
                          <ListItemSecondaryAction className={classes.listAction}>
                            <Grid container justifyContent="flex-end">
                              <Grid item></Grid>
                              <Grid item>
                                <Typography variant="caption" display="block" gutterBottom className={classes.actionColor}></Typography>
                              </Grid>
                            </Grid>
                          </ListItemSecondaryAction>
                        </ListItem>
                      )
                    )} */}
                  </PerfectScrollbar>
                </List>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </React.Fragment>
  );
};

export default NotificationSection;
